import { Component, Output, EventEmitter } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, GridApi } from 'ag-grid-community';
import { ChangeDetectorRef } from '@angular/core';
import { faEdit, faFloppyDisk, faXmark, faPenToSquare } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-pool-point-actions-cell-renderer',
  templateUrl: './pool-point-actions-cell-renderer.component.html',
  styleUrls: ['./pool-point-actions-cell-renderer.component.scss']
})
export class PoolPointActionsCellRendererComponent implements ICellRendererAngularComp{
  @Output() editClicked = new EventEmitter<any>();
  params: any;
  isEditing: boolean = false;
  g!: GridApi;
  userModifiedData: any;

  faEdit = faPenToSquare;
  faSave = faFloppyDisk;
  faCancel = faXmark;

  constructor(private cdRef: ChangeDetectorRef){}

  agInit(params: any): void {
    this.params = params;
    this.g = params.api;
    this.userModifiedData = params.context;
  }

  refresh(): boolean {
    return false;
  }

  onEditClick(event: Event) {
    event.stopPropagation(); // prevents row click events
    // if (this.params.onEdit) {
    //   this.params.onEdit(this.params);
    // }
    console.log('called onEditClick from cell renderer')
    if (this.params?.onEditClick) {
      console.log('setting editing to true');
      this.isEditing = true;
      const rowIndex = this.params.node.rowIndex;
      if(rowIndex !== null){
        this.g.startEditingCell({
          rowIndex: rowIndex,
          colKey: 'pool_point_name'
        })
      } else {
        console.log('uh oh, rowIndex is null')
      }

    } else {
      console.warn('onEditClick not provided in cellRendererParams');
    }
  }

  onCancelClick(){
    this.isEditing = false;
    this.g.stopEditing(true);
    console.log('cancelling edit')
  }

  onSaveClick(){
    this.isEditing = false
    this.g.stopEditing(false);
    this.userModifiedData = this.params.context.userModifiedData
    console.log(this.userModifiedData);
  }

  onDeactivateClicked(event: Event) {
    event.stopPropagation();
    if (this.params.onDelete) {
      this.params.onDelete(this.params);
    }
  }
}
